import { FunctionalComponent, h } from 'preact';
import { Router } from 'preact-router';
import './style.css';
import Home from '../routes/home';
import Blogger from '../routes/blogger';
import Extension from '../routes/extension';
import ShareTool from '../routes/sharetool';
import NotFoundPage from '../routes/notfound';
import Community from '../routes/community';
// Import the view directly so preact-cli does not wrap it in an async route placeholder.
import SearchPage from '../routes/searchPage/SearchPage';
import CommunityCollect from '../routes/communityCollect';
import Mtqq from '../routes/mtqq';
import NewCommunity from '../routes/newCommunity';
// 新版直播预告作为首页，旧版页面保留独立入口。
import LiveHome from '../routes/live';
import LiveFeatured from '../routes/live/featured';
import LiveCalendar from '../routes/live/calendar';
import LiveSearch from '../routes/live/search';
import Store from '../store';
import 'lib-flexible';
import 'antd-mobile/es/global';

const App: FunctionalComponent = () => {
  return (
    <div id="preact_root">
      <Router>
        <Home path="/home" store={Store} />
        <Blogger path="/blogger" store={Store} />
        <ShareTool path="/sharetool" store={Store} />
        <Community path="/community" store={Store} />
        <CommunityCollect path="/communityCollect" store={Store} />
        <SearchPage path="/searchpage" store={Store} />
        <Mtqq path="/mtqq" store={Store} />
        <Extension path="/legacy" store={Store} />
        <NewCommunity path="/newCommunity" store={Store} />
        <LiveHome path="/" />
        <LiveHome path="/live" />
        <LiveFeatured path="/live/featured" />
        <LiveCalendar path="/live/calendar" />
        <LiveSearch path="/live/search" />
        <NotFoundPage default />
      </Router>
      <div id="container" />
    </div>
  );
};

export default App;
